import { createAction } from 'redux-actions';
import { PapiOriginalsResponse } from '@wix/da-papi-types';

export const fetchOriginalsOrderDetails = createAction(
  'ORIGINALS.FETCH_ORDER_DETAILS',
  (payload: {
    deviationId: number;
    orderId: number;
    onSuccess: (order: PapiOriginalsResponse) => void;
    onError: (error: Error) => void;
  }) => payload
);
